import Glasses from "assets/icons/Glasses";
import {useEffect, useRef} from "react";
// @ts-ignore

import bvi from "bvi/src/js/bvi";

const BviOnButton = () => {
  const didInit = useRef(false);

  useEffect(() => {
    if (didInit.current) return;
    didInit.current = true;
    new bvi()
  },[])

  return (
    <a className={'bvi-open'} href={'#'}>
      <Glasses sx={{width: 16, height: 16, color: 'grey.200'}}/>
    </a>
  )
}

export default BviOnButton;
